import { parsedUser } from "../../utils/GetCurrentUser";
import { useToast } from "../../contexts/toast";
import { useEffect, useState } from "react";
import API from "../../api/api";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import PieChart, { Label, Legend, Series, Connector, Font } from "devextreme-react/pie-chart";
import Chart, {
  ArgumentAxis,
  ValueAxis,
  CommonSeriesSettings,
  Series as ChartSeries,
  Tooltip,
  Legend as ChartLegend,
  Grid,
  Point,
  Label as ChartLabel,
  Format,
  Tick
} from "devextreme-react/chart";
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import "./GenericDashboard.css";

// Componente personalizado para el botón de cerrar modal
const CustomCloseButton = ({ onClose }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={{
        border: "1px solid #b0b0b0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        backgroundColor: isHovered ? "#ff4136" : "",
        cursor: "pointer"
      }}
      className="btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClose}
      aria-label="Close"
    >
      <i 
        style={{ 
          fontSize: "20px", 
          color: isHovered ? "#ffffff" : "#b0b0b0",
          transition: "color 0.2s ease"
        }} 
        className="fa-solid fa-xmark"
      ></i>
    </button>
  );
};

const GenericDashboard = () => {

    const user = parsedUser();
  const toast = useToast();

  const [gridConfig, setGridConfig] = useState(null);
  const [chartItems, setChartItems] = useState([]);
  const [formTitle, setFormTitle] = useState("");
  const [formPath, setFormPath] = useState("");
  const [formIcon, setFormIcon] = useState("");
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  // Estados para el modal de maximizar gráficos
  const [isChartMaximized, setIsChartMaximized] = useState(false);
  const [currentChartIndex, setCurrentChartIndex] = useState(0);
  const [chartsForNavigation, setChartsForNavigation] = useState([]);

  const { id } = useParams();

  const CustomPieChart = ({data, fontColor, labelPosition, connectorVisible, connectorWidth}) => {

    const customizeLabel = (pointInfo) => {
      return `${pointInfo.argumentText}: ${pointInfo.valueText}`;
    };

    const customizePoint = (pointInfo) => {
      if (pointInfo.data && pointInfo.data.color) {
        return { color: pointInfo.data.color };
      }
      return {};
    };

      
      console.log("🔍 Pie Chart data:", data);
      console.log("🔍 Pie Chart customizePoint:", customizePoint);
      console.log("🔍 Pie Chart customizeLabel:", customizeLabel);
      console.log("🔍 Pie Chart fontColor:", fontColor);

      if (data === undefined) {
          return <div>No data</div>;
      }
    return (
        <PieChart
            dataSource={data}
            resolveLabelOverlapping="shift"
            innerRadius={0.65}
            type="doughnut"
            customizePoint={customizePoint}
            height="100%"
            width="100%"
          >
            <Series argumentField="category" valueField="value">
              <Label
                visible={true}
                format="fixedPoint"
                customizeText={customizeLabel}
                position={labelPosition || "inside"}
                font={{
                  size: 11,
                  weight: 700,
                  color: fontColor
                }}
              >
                {connectorVisible === "true" && (
                  <Connector visible={true} width={parseFloat(connectorWidth) || 1}></Connector>
                )}
              </Label>
            </Series>

            <Legend visible={false} />
          </PieChart>
    )
  }

  const CustomBarChart = ({chartData, seriesConfig}) => {
    console.log("🔍 Bar Chart chartData:", chartData);
    console.log("🔍 Bar Chart seriesConfig:", seriesConfig);

    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    // Colores por tipo de stack (fallback si no viene Color del backend)
    const getColorBySeries = (field, stack) => {
      // Entradas en tonos verdes
      if (stack === "Entradas") {
        return field.includes("H") ? "#4CAF50" : "#8BC34A"; // Hombres verde oscuro, Mujeres verde claro
      }
      // Salidas en tonos rojos
      if (stack === "Salidas") {
        return field.includes("H") ? "#F44336" : "#EF5350"; // Hombres rojo oscuro, Mujeres rojo claro
      }
      return "#999999";
    };

    return (
      <Chart
        dataSource={chartData}
        height="100%"
        width="100%"
      >
        {seriesConfig.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Field}
            name={serie.Title}
            type="bar"
            stack={serie.Stack}
            color={serie.Color || getColorBySeries(serie.Field, serie.Stack)}
          />
        ))}

        <CommonSeriesSettings
          argumentField="Mes"
          type="bar"
          ignoreEmptyPoints={true}
        />

        <ArgumentAxis>
          <Label rotationAngle={-45} overlappingBehavior="rotate" />
        </ArgumentAxis>

        <ValueAxis>
          <Label format="fixedPoint" />
        </ValueAxis>

        <ChartLegend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />

        <Tooltip
          enabled={true}
          customizeTooltip={(pointInfo) => ({
            text: `${pointInfo.seriesName}: ${pointInfo.valueText}`
          })}
        />
      </Chart>
    );
  }

  // Función para renderizar Items tipo Card
  const renderCardItem = (item, hasGridConfig) => {
    // Verificar si ItemData tiene la nueva estructura (Grid e Items) o la antigua (array directo)
    const hasNewStructure = item.ItemData && !Array.isArray(item.ItemData) && item.ItemData.Items;
    const cards = hasNewStructure ? item.ItemData.Items : (Array.isArray(item.ItemData) ? item.ItemData : []);
    
    // Si el item tiene GridRow con span 4 o más, son cards verticales de estado
    const isVerticalList = item.GridRow && (item.GridRow.includes('span 4') || item.GridRow.includes('span 6'));
    
    if (isVerticalList) {
      return (
        <>
          {cards.map((card, index) => (
            <div 
              key={index} 
              className="estado-card-container"
              style={{
                // Si tiene grid y Width/Height son "span X", usar grid positioning
                // Si no, usar width/height normales
                ...(hasGridConfig && card.Width?.includes('span') ? { gridColumn: card.Width } : { width: card.Width }),
                ...(hasGridConfig && card.Height?.includes('span') ? { gridRow: card.Height } : { height: card.Height })
              }}
            >
              <div className="estado-card" style={{ backgroundColor: card.BackColor }}>
                <div className="estado-icon" style={{ color: card.ForeColor }}>
                  <i className={card.Icon}></i>
                </div>
                <div className="estado-text" style={{ color: card.ForeColor }}>{card.Kpi}</div>
              </div>
              <div className="estado-value" style={{ backgroundColor: card.ForeColor }}>
                {card.Valor}
              </div>
            </div>
          ))}
        </>
      );
    }

    // Cards horizontales normales (header)
    return (
      <>
        {cards.map((card, index) => (
          <div 
            key={index}
            className="general-card-item"
            style={{ 
              // Si tiene grid y Width/Height son "span X", usar grid positioning
              // Si no, usar width/height normales
              ...(hasGridConfig && card.Width?.includes('span') ? { gridColumn: card.Width } : { width: card.Width }),
              ...(hasGridConfig && card.Height?.includes('span') ? { gridRow: card.Height } : { height: card.Height })
            }}
          >
            <div
              className="general-stat-card"
              style={{ backgroundColor: card.BackColor }}
            >
              <div
                className="general-card-header"
                style={{ backgroundColor: card.ForeColor, color: card.BackColor }}
              >
                {card.Kpi}
              </div>
              <div className="general-card-body">
                <div
                  className="general-card-icon"
                  style={{ color: card.ForeColor }}
                >
                  <i className={card.Icon}></i>
                </div>
                <div
                  className="general-card-value"
                  style={{ color: card.ForeColor }}
                >
                  {card.Valor}
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  // Función para renderizar Items tipo Pies (múltiples gráficos de dona)
  const renderPiesItem = (item, showMaximizeButton = false, onMaximize = null) => {
    return (
      <div className="bg-white p-3 shadow" style={{ borderRadius: 15, height: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.ItemTitle}</h5>
          {showMaximizeButton && onMaximize && (
            <button
              onClick={onMaximize}
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                padding: '10px',
                cursor: 'pointer',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                flexShrink: 0,
                marginLeft: '10px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                e.currentTarget.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                e.currentTarget.style.transform = 'scale(1)';
              }}
              title="Maximizar gráfico"
            >
              <i className="fas fa-expand-alt"></i>
            </button>
          )}
        </div>
        <div 
          className="chart-donut-container"
          style={{
            padding: item.ItemPadding || undefined
          }}
        >
          {item.ItemData.map((serieData, index) => (
            <div key={index} className="donut-item">
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <h6 style={{ marginBottom: '5px', fontWeight: 600, color: '#3d4d5c', fontSize: '12px', flexShrink: 0 }}>
                  {serieData.Serie}
                </h6>
                <PieChart
                  dataSource={serieData.Data.map(d => ({
                    category: d.Kpi,
                    value: d.Valor,
                    color: d.BackColor
                  }))}
                  resolveLabelOverlapping="shift"
                  innerRadius={0.7}
                  type="doughnut"
                  customizePoint={(pointInfo) => ({ color: pointInfo.data.color })}
                >
                  <Series argumentField="category" valueField="value">
                    <Label
                      visible={true}
                      format="fixedPoint"
                      customizeText={(pointInfo) => `${pointInfo.argumentText}: ${pointInfo.valueText}`}
                      position={item.LabelPosition || "columns"}
                    >
                      {item.ItemConnectorVisible === "true" && (
                        <Connector visible={true} width={parseFloat(item.ItemConnectorWidth) || 1}></Connector>
                      )}
                      <Font size={10} weight={600} color="#FFFFFF" />
                    </Label>
                  </Series>
                  <Legend visible={false} />
                </PieChart>
              </div>
            </div>
          ))}
        </div>
        </div>
    );
  };

  // Función para renderizar gráfico tipo Spline (líneas múltiples con doble eje Y)
  const renderSplineChart = (chartData, seriesConfig) => {
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    return (
      <Chart
        dataSource={chartData}
        style={{ height: "100%" }}
      >
        <CommonSeriesSettings
          argumentField="Periodo"
          type="spline"
        >
          <Point hoverMode="allArgumentPoints" />
        </CommonSeriesSettings>

        {seriesConfig.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Serie}
            name={serie.Kpi}
            color={serie.Color}
            axis={serie.Group === 2 ? "secondary" : "primary"}
          />
        ))}

        <ArgumentAxis>
          <Grid visible={true} />
        </ArgumentAxis>

        <ValueAxis name="primary">
          <Grid visible={true} />
        </ValueAxis>

        <ValueAxis name="secondary" position="right">
          <Grid visible={false} />
        </ValueAxis>

        <ChartLegend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />

        <Tooltip enabled={true} />
      </Chart>
    );
  };

  // Función para renderizar gráfico tipo Stacked (barras horizontales apiladas)
  const renderStackedChart = (chartData, seriesConfig) => {
    console.log("🔍 Stacked Chart Data:", chartData);
    console.log("🔍 Stacked Series Config:", seriesConfig);
    
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    // Filtrar series duplicadas por Serie (valueField)
    const uniqueSeries = seriesConfig.reduce((acc, serie) => {
      if (!acc.find(s => s.Serie === serie.Serie)) {
        acc.push(serie);
      }
      return acc;
    }, []);

    console.log("🔍 Unique Series:", uniqueSeries);

    return (
      <Chart
        dataSource={chartData}
        style={{ height: "100%" }}
        rotated={id === "bc61cfe4d54f23faad5f1ced4d081c36ee0a54243d0f203c49bbb128506c1d758b044ca0149cbeed7ad4337c1814f3d7795115534bb5651eab7b5ec1ece36b98"}
      >
        <CommonSeriesSettings
          argumentField="Periodo"
          type="stackedBar"
        />

        {uniqueSeries.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Serie}
            name={serie.Kpi}
            color={serie.Color}
            stack="total"
          />
        ))}

        <ArgumentAxis>
          <Grid visible={false} />
        </ArgumentAxis>

        <ValueAxis>
          <Grid visible={true} />
        </ValueAxis>

        <ChartLegend
          visible={true}
          verticalAlignment="bottom"
          horizontalAlignment="center"
          itemTextPosition="right"
        />

        <Tooltip enabled={true} />
      </Chart>
    );
  };

  // Función para renderizar gráfico tipo Clustered (barras verticales agrupadas)
  const renderClusteredChart = (chartData, seriesConfig) => {
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    return (
      <Chart
        dataSource={chartData}
        style={{ height: "100%" }}
      >
        <CommonSeriesSettings
          argumentField="Periodo"
          type="bar"
        />

        {seriesConfig.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Serie}
            name={serie.Kpi}
            color={serie.Color}
          />
        ))}

        <ArgumentAxis>
          <Grid visible={false} />
        </ArgumentAxis>

        <ValueAxis>
          <Grid visible={true} />
        </ValueAxis>

        <ChartLegend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />

        <Tooltip enabled={true} />
      </Chart>
    );
  };

  // Función para renderizar Items tipo StackedBar (barras horizontales apiladas con labels)
  const renderStackedBarItem = (item) => {
    if (!item.ItemData || !item.ItemData[0]) return null;

    const chartData = item.ItemData[0];
    const series = chartData.Series;
    const data = chartData.Data.map(d => {
      const dataPoint = { name: d.Kpi };
      series.forEach(s => {
        dataPoint[s.Serie] = d[s.Serie];
      });
      return dataPoint;
    });

    return (
      <Chart
        dataSource={data}
        rotated={true}
        barGroupPadding={0.2}
        style={{ height: "100%" }}
      >
        <CommonSeriesSettings
          argumentField="name"
          type="stackedBar"
          hoverMode="allArgumentPoints"
          selectionMode="allArgumentPoints"
        >
          <ChartLabel visible={true}>
            <Format type="fixedPoint" precision={0} />
            <Font size={14} weight={600} />
          </ChartLabel>
        </CommonSeriesSettings>

        {series.map((serie, index) => (
          <ChartSeries 
            key={index}
            valueField={serie.Serie} 
            name={serie.Kpi}
            color={serie.Color} 
            stack="total" 
          />
        ))}

        <ArgumentAxis>
          <Font size={12} />
        </ArgumentAxis>

        <ValueAxis>
          <Tick visible={true} />
        </ValueAxis>

        <ChartLegend visible={false} />
      </Chart>
    );
  };

  // Funciones para el modal de maximizar gráficos
  const openChartMaximized = (chartIndex) => {
    // Filtrar solo los gráficos que no sean Card
    const nonCardCharts = chartItems.filter(item => item.type !== "Card");
    setChartsForNavigation(nonCardCharts);
    
    // Encontrar el índice del gráfico seleccionado en la lista filtrada
    const selectedChartIndexInFiltered = nonCardCharts.findIndex(
      chart => chart.itemIndex === chartItems[chartIndex].itemIndex
    );
    
    setCurrentChartIndex(selectedChartIndexInFiltered);
    setIsChartMaximized(true);
  };

  const closeChartMaximized = () => {
    setIsChartMaximized(false);
  };

  const goToPreviousChart = () => {
    setCurrentChartIndex((prev) => (prev > 0 ? prev - 1 : chartsForNavigation.length - 1));
  };

  const goToNextChart = () => {
    setCurrentChartIndex((prev) => (prev < chartsForNavigation.length - 1 ? prev + 1 : 0));
  };

  // Función para renderizar el contenido del gráfico en el modal
  const renderMaximizedChart = (item) => {
    if (!item) return null;

    return (
      <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
        {item.type === "Pies" && renderPiesItem(item.rawItem, false)}
        
        {item.type === "Spline" && (
          <>
            <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
              {renderSplineChart(item.data, item.seriesConfig)}
            </div>
          </>
        )}
        
        {item.type === "Stacked" && (
          <>
            <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
              {renderStackedChart(item.data, item.seriesConfig)}
            </div>
          </>
        )}
        
        {item.type === "Clustered" && (
          <>
            <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
              {renderClusteredChart(item.data, item.seriesConfig)}
            </div>
          </>
        )}
        
        {item.type === "StackedBar" && (
          <>
            <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
              {renderStackedBarItem(item.rawItem)}
            </div>
          </>
        )}
        
        {item.type !== "Card" && item.type !== "Pies" && item.type !== "Spline" && item.type !== "Stacked" && item.type !== "Clustered" && item.type !== "StackedBar" && (
          <>
            <div style={{ 
              flex: 1, 
              minHeight: 0, 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center", 
              width: "100%",
              padding: item.type === "Pie" && item.itemPadding ? item.itemPadding : "16px"
            }}>
              {item.type === "Pie" && <CustomPieChart 
                data={item.data} 
                fontColor={item.isEstado ? undefined : "#FFFFFF"} 
                labelPosition={item.labelPosition}
                connectorVisible={item.connectorVisible}
                connectorWidth={item.connectorWidth}
              />}
              {item.type === "ClusteredStacked" && <CustomBarChart chartData={item.data} seriesConfig={item.seriesConfig} />}
            </div>
          </>
        )}
      </div>
    );
  };

    const getDataDashboard = async () => {
        try {
          setIsRefreshing(true);
          console.log("🔍 Obteniendo datos del Dashboard de Alojamientos...");
    
          // Enviar Token e IdUser como enteros
          const query = `Token=${user.Token}&IdUser=${user.IdUser}&id=${id}`;
    
          const response = await API.getAction(`api/OcupacionProcesos/Dashboard?${query}`, null);
    
          console.log("📊 Dashboard Response:", response.data);
    
          if (response.data && response.data.length > 0) {
            // Parsear el primer nivel de JSONData
            let firstLevel = JSON.parse(response.data[0].JSONData);
            console.log("📋 Primera capa Dashboard (parseada):", firstLevel);
    
            // Verificar errores
            if (firstLevel.Error) {
              toast({
                type: "error",
                message: firstLevel.Msg || "Error al obtener datos del Dashboard"
              });
              return;
            }
    
            const dashboardData = firstLevel.DashboardData;
    
            // Extraer información del formulario (si existe)
            if (dashboardData.FormTitle) {
              setFormTitle(dashboardData.FormTitle);
            }
            if (dashboardData.FormPath) {
              setFormPath(dashboardData.FormPath);
            }
            if (dashboardData.FormIcon) {
              setFormIcon(dashboardData.FormIcon);
            }
    
            // Configuración del Grid
            if (dashboardData.Grid) {
              setGridConfig(dashboardData.Grid);
              console.log("✅ Grid config cargada:", dashboardData.Grid);
            }
    
            // Procesar Items
            if (dashboardData.Items && dashboardData.Items.length > 0) {
              const mappedItems = dashboardData.Items.map(item => {
                // Para los gráficos de Estado y Área de Personal, invertir los colores
                const isSpecialChart = item.ItemTitle === "Estado" || item.ItemTitle === "Area de Personal";
                
                let chartData;
                let seriesConfig = null;
                
                // Procesamiento específico según el tipo de gráfico
                if (item.ItemType === "ClusteredStacked" || item.ItemType === "Spline" || item.ItemType === "Clustered" || item.ItemType === "Stacked") {
                  // El formato es: ItemData[0].Series y ItemData[0].Data
                  if (item.ItemData && item.ItemData.length > 0 && item.ItemData[0].Series && item.ItemData[0].Data) {
                    seriesConfig = item.ItemData[0].Series;
                    chartData = item.ItemData[0].Data;
                  } else {
                    chartData = [];
                    seriesConfig = [];
                  }
                } else if (item.ItemType === "Card" || item.ItemType === "Pies" || item.ItemType === "StackedBar") {
                  // Card, Pies y StackedBar se pasan directamente sin transformar
                  chartData = item.ItemData;
                } else {
                  // Procesamiento para gráficos Pie
                  chartData = item.ItemData.map(dataItem => ({
                    category: dataItem.Kpi,
                    value: parseInt(dataItem.Valor),
                    // Estado y Área de Personal usan ForeColor para background, los demás usan BackColor
                    color: isSpecialChart ? dataItem.ForeColor : (dataItem.BackColor || dataItem.ForeColor),
                    // Guardar ambos colores para gráficos especiales
                    textColor: isSpecialChart ? dataItem.BackColor : undefined
                  }));
                }

                return {
                  itemIndex: item.ItemIndex,
                  title: item.ItemTitle,
                  type: item.ItemType,
                  gridRow: item.GridRow,
                  gridCol: item.GridCol,
                  data: chartData,
                  seriesConfig: seriesConfig,
                  isEstado: isSpecialChart,
                  rawItem: item, // Guardar el item completo para Card y Pies
                  // Propiedades para gráficos Pie
                  labelPosition: item.LabelPosition,
                  connectorVisible: item.ItemConnectorVisible,
                  connectorWidth: item.ItemConnectorWidth,
                  itemPadding: item.ItemPadding
                };
              });
    
              setChartItems(mappedItems);
              console.log("✅ Items cargados:", mappedItems.length, "gráficos");
            }
    
          } else {
            console.warn("⚠️ No se recibieron datos para el dashboard.");
            toast({
              type: "info",
              message: "No hay datos disponibles para mostrar"
            });
          }
    
        } catch (error) {
          console.error("❌ Error al obtener datos del Dashboard:", error);
          toast({
            type: "error",
            message: "No se pudieron cargar los datos del dashboard"
          });
        } finally {
          setIsRefreshing(false);
        }
      };

      useEffect(() => {
        if (user && user.Token && user.IdUser && id) {
          // Limpiar datos anteriores antes de cargar nuevos
          setGridConfig(null);
          setChartItems([]);
          setFormTitle("");
          setFormPath("");
          setFormIcon("");
          setIsRefreshing(false);
          getDataDashboard();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [id]);


  return (
    <>
      <Breadcrumbs pathTitle={formPath || "Dashboard"} />

      {formTitle && (
        <div className="row mx-0">
          <div className="d-flex align-items-center justify-content-between my-1">
            <div className="d-flex align-items-center">
              {formIcon && <i className={formIcon + " me-3 fa-2x"}></i>}
              <div className="d-flex flex-column">
                <h5 className={"my-1"}>{formTitle}</h5>
              </div>
            </div>
            {/* BOTÓN DE ACTUALIZAR */}
            <div>
              <button
                onClick={getDataDashboard}
                disabled={isRefreshing}
                style={{
                  padding: '10px 20px',
                  backgroundColor: isRefreshing ? '#cccccc' : '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: isRefreshing ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <i className={`fas fa-sync-alt ${isRefreshing ? 'fa-spin' : ''}`}></i>
                {isRefreshing ? 'Actualizando...' : 'Actualizar Datos'}
              </button>
            </div>
          </div>
        </div>
      )}

      {gridConfig && (
        <div 
          className="dashboard-grid-container"
          style={{
            gridTemplateRows: gridConfig.Rows,
            gridTemplateColumns: gridConfig.Cols,
            gap: gridConfig.Gap,
            padding: gridConfig.Padding,
            height: gridConfig.height,
          }}
        >
          {chartItems.map((item, index) => {
            // Obtener configuración del grid para Cards
            const cardGridConfig = item.type === "Card" ? item.rawItem.ItemData?.Grid : null;
            const hasGridConfig = !!cardGridConfig;
            
            // Si es Card y NO tiene Grid, usar flex (estructura antigua)
            const useFlexLayout = item.type === "Card" && !hasGridConfig;
            
            return (
              <div
                key={index}
                style={{ 
                  width: "100%", 
                  // Cards sin grid necesitan altura automática para expandirse, otros tipos usan 100%
                  height: useFlexLayout ? "auto" : "100%", 
                  gridRow: item.gridRow, 
                  gridColumn: item.gridCol,
                  position: "relative"
                }}
              >
                <div 
                   className={`bg-white shadow ${item.type === "Card" || item.type === "Pies" || item.type === "Spline" || item.type === "Stacked" || item.type === "Clustered" || item.type === "StackedBar" ? "" : "custom-flex"}`}
                   style={{ 
                     borderRadius: 15,
                     // Cards con grid mantienen 100%, otros ajustan según el contenido
                     height: "100%",
                     position: "relative",
                     // Aplicar grid interno solo para Cards con configuración de Grid
                     ...(hasGridConfig ? {
                       display: 'grid',
                       gridTemplateRows: cardGridConfig.Rows || 'repeat(1, 1fr)',
                       gridTemplateColumns: cardGridConfig.Cols || 'repeat(12, 1fr)',
                       gap: cardGridConfig.Gap || '10px',
                       padding: cardGridConfig.Padding || '10px',
                       backgroundColor: cardGridConfig.background || '#ffffff',
                     } : useFlexLayout ? {
                       display: 'flex',
                       flexDirection: 'column',
                       gap: '10px',
                       padding: '10px',
                       justifyContent: 'space-between',
                     } : {})
                   }}
                 >
                   {/* Renderizado condicional según el tipo */}
                   {item.type === "Card" && renderCardItem(item.rawItem, hasGridConfig)}
                   {item.type === "Pies" && renderPiesItem(item.rawItem, true, () => openChartMaximized(index))}
                   
                   {item.type === "Spline" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <button
                          onClick={() => openChartMaximized(index)}
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '10px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                            marginLeft: '10px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                          title="Maximizar gráfico"
                        >
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderSplineChart(item.data, item.seriesConfig)}
                      </div>
                    </>
                   )}
                   
                   {item.type === "Stacked" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <button
                          onClick={() => openChartMaximized(index)}
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '10px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                            marginLeft: '10px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                          title="Maximizar gráfico"
                        >
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderStackedChart(item.data, item.seriesConfig)}
                      </div>
                    </>
                   )}
                   
                   {item.type === "Clustered" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <button
                          onClick={() => openChartMaximized(index)}
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '10px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                            marginLeft: '10px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                          title="Maximizar gráfico"
                        >
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderClusteredChart(item.data, item.seriesConfig)}
                      </div>
                    </>
                   )}
                   
                   {item.type === "StackedBar" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <button
                          onClick={() => openChartMaximized(index)}
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '10px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                            marginLeft: '10px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                          title="Maximizar gráfico"
                        >
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderStackedBarItem(item.rawItem)}
                      </div>
                    </>
                   )}
                   
                   {item.type !== "Card" && item.type !== "Pies" && item.type !== "Spline" && item.type !== "Stacked" && item.type !== "Clustered" && item.type !== "StackedBar" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <button
                          onClick={() => openChartMaximized(index)}
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '10px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                            marginLeft: '10px'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                            e.currentTarget.style.transform = 'scale(1.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                            e.currentTarget.style.transform = 'scale(1)';
                          }}
                          title="Maximizar gráfico"
                        >
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        width: "100%",
                        padding: item.type === "Pie" && item.itemPadding ? item.itemPadding : undefined
                      }}>
                        {item.type === "Pie" && <CustomPieChart 
                          data={item.data} 
                          fontColor={item.isEstado ? undefined : "#FFFFFF"} 
                          labelPosition={item.labelPosition}
                          connectorVisible={item.connectorVisible}
                          connectorWidth={item.connectorWidth}
                        />}
                        {item.type === "ClusteredStacked" && <CustomBarChart chartData={item.data} seriesConfig={item.seriesConfig} />}
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal para maximizar gráficos */}
      {isChartMaximized && chartsForNavigation.length > 0 && (
        <Modal
          show={isChartMaximized}
          onHide={closeChartMaximized}
          size="xl"
          fullscreen={true}
          centered
          className="chart-maximized-modal"
          style={{ zIndex: 9999 }}
        >
          <Modal.Header style={{ backgroundColor: '#000', color: '#fff', border: 'none' }}>
            <Modal.Title>
              {chartsForNavigation[currentChartIndex]?.title}
            </Modal.Title>
            <CustomCloseButton onClose={closeChartMaximized} />
          </Modal.Header>
          <Modal.Body style={{ 
            backgroundColor: '#f8f9fa', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            position: 'relative',
            padding: '40px',
            height: 'calc(100vh - 60px)',
            zIndex: 10000
          }}>
            {/* Contenedor del gráfico */}
            <div style={{ 
              width: '100%',
              height: '100%', 
              backgroundColor: '#ffffff',
              borderRadius: '15px',
              padding: '20px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              flexDirection: 'column'
            }}>
              {renderMaximizedChart(chartsForNavigation[currentChartIndex])}
            </div>

            {/* Botón Anterior */}
            {chartsForNavigation.length > 1 && (
              <button
                onClick={goToPreviousChart}
                style={{
                  position: 'absolute',
                  left: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  zIndex: 1000
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                }}
                title="Gráfico anterior"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
            )}

            {/* Botón Siguiente */}
            {chartsForNavigation.length > 1 && (
              <button
                onClick={goToNextChart}
                style={{
                  position: 'absolute',
                  right: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  zIndex: 1000
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                }}
                title="Gráfico siguiente"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            )}

            {/* Indicador de posición */}
            {chartsForNavigation.length > 1 && (
              <div style={{
                position: 'absolute',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                {currentChartIndex + 1} / {chartsForNavigation.length}
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export default GenericDashboard